const _excluded = ["className", "children", "headTitle"],
  _excluded2 = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import cn from 'classnames';
import { Typography } from 'seagull';
import styles from "./CommonComponents.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AgreementViewCard(_ref) {
  let {
      className,
      children,
      headTitle
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("section", _objectSpread(_objectSpread({
    className: cn(styles.card, className)
  }, rest), {}, {
    children: [headTitle && /*#__PURE__*/_jsx(SectionTitle, {
      className: styles.sectionTitle,
      children: headTitle
    }), children]
  }));
}
export function SectionTitle(_ref2) {
  let {
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({}, props), {}, {
    variant: "h5",
    children: children
  }));
}
export function Logo(_ref3) {
  let {
    logoUrl
  } = _ref3;
  return /*#__PURE__*/_jsx("div", {
    className: styles.logoContainer,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.circle,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.logoImageBorder
      }), /*#__PURE__*/_jsx("div", {
        className: styles.logoImageContainer,
        style: {
          backgroundImage: "url(".concat(logoUrl, ")")
        }
      })]
    })
  });
}
export function TopStripe(_ref4) {
  let {
    backgroundColor
  } = _ref4;
  return /*#__PURE__*/_jsx("div", {
    className: styles.topStripe,
    style: {
      backgroundColor
    }
  });
}
export function SpecificTerm(props) {
  const {
    field,
    value,
    testid,
    changes
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Typography, {
      weight: "bold",
      children: field
    }), /*#__PURE__*/_jsx(Typography, {
      "data-testid": testid,
      children: value
    }), changes && /*#__PURE__*/_jsx("div", {
      className: styles.changes,
      children: changes
    })]
  });
}